export default __webpack_public_path__ + "static/media/markEmailUnread.cd04b074.svg";